/**
 * Returns a valid URL query string to be used in routes
 *
 * @param {Object} params
 * @returns String
 */
export default function createQueryString(obj: { [key: string]: string }) {
  return new URLSearchParams(obj).toString()
}
